export interface PriceCnvState {

}

export const initialState: any = []